class IpaxTrustBarCarousel {
  static MOBILE_QUERY = '(max-width: 990px)';

  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-ipax-trust-bar-track]');
    this.slides = [...root.querySelectorAll('[data-ipax-trust-bar-slide]')];
    this.mediaQuery = window.matchMedia(IpaxTrustBarCarousel.MOBILE_QUERY);
    this.index = 0;
    this.autoplayTimer = null;
    this.touchStartX = 0;

    if (!this.track || this.slides.length <= 1) return;

    this.bindEvents();
    this.onBreakpointChange();

    this.mediaQuery.addEventListener('change', () => this.onBreakpointChange());
  }

  bindEvents() {
    this.root.addEventListener('touchstart', (event) => {
      if (!this.isMobile()) return;
      this.touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    this.root.addEventListener('touchend', (event) => {
      if (!this.isMobile()) return;
      const delta = event.changedTouches[0].screenX - this.touchStartX;
      if (Math.abs(delta) < 40) return;
      this.step(delta < 0 ? 1 : -1);
    }, { passive: true });
  }

  isMobile() {
    return this.mediaQuery.matches;
  }

  onBreakpointChange() {
    if (this.isMobile()) {
      this.goTo(this.index, false);
      if (this.root.dataset.autoplay === 'true') this.startAutoplay();
      return;
    }

    this.stopAutoplay();
    this.track.style.transition = 'none';
    this.track.style.transform = 'none';
  }

  step(direction) {
    const next = (this.index + direction + this.slides.length) % this.slides.length;
    this.goTo(next);
    if (this.root.dataset.autoplay === 'true') {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  goTo(index, animate = true) {
    if (!this.isMobile()) return;

    this.index = index;
    this.track.style.transition = animate ? 'transform 0.42s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    this.track.style.transform = `translateX(-${index * 100}%)`;
  }

  startAutoplay() {
    if (!this.isMobile()) return;

    this.stopAutoplay();
    const speed = Number(this.root.dataset.autoplaySpeed) || 4500;
    this.autoplayTimer = window.setInterval(() => this.step(1), speed);
  }

  stopAutoplay() {
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ipax-trust-bar]').forEach((root) => {
    new IpaxTrustBarCarousel(root);
  });
});
